import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useHeaderSlot } from '@src/app/layout';
import { PAGE_LAYOUT_SCROLL_CONTAINER_ID } from '@src/app/layout/Page/constants';
import { ToastContainer } from '@src/app/notifications/toast';
import type { Theme } from '@src/app/themes';
import { useAuthentication } from '@src/features/auth';
import { Box } from '@src/shared/ui/layout';

const StyleSheet = {
  header: (theme: Theme, isScrolled: boolean) => ({
    position: 'relative',
    backgroundColor: isScrolled ? 'grey.100' : 'transparent',
    boxShadow: isScrolled ? `0 -1px ${theme.palette.grey[200]} inset` : 'none',
    m: isScrolled ? '-25px -20px 0 -10px' : 0,
    p: isScrolled ? '25px 20px 10px 10px' : '0 0 10px',
    transition: 'background-color 180ms ease, box-shadow 180ms ease',
  }),
  loginAsNotification: {
    position: 'absolute',
    top: '10px',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'red.100',
    padding: '0 16px',
    opacity: 0.8,
  },
};
export default function Header() {
  const theme = useTheme();
  const { user, credentials } = useAuthentication();
  const { headerSlot } = useHeaderSlot();
  const [isScrolled, setIsScrolled] = useState(false);
  const loginAs = credentials?.loginAs ?? false;

  useEffect(() => {
    const syncFromScrollContainer = () => {
      const scrollContainer = document.getElementById(
        PAGE_LAYOUT_SCROLL_CONTAINER_ID,
      );
      setIsScrolled(Boolean(scrollContainer && scrollContainer.scrollTop > 0));
    };

    const onScroll = (event: Event) => {
      const target = event.target;
      if (
        !(target instanceof HTMLElement) ||
        target.id !== PAGE_LAYOUT_SCROLL_CONTAINER_ID
      ) {
        return;
      }

      setIsScrolled(target.scrollTop > 0);
    };

    syncFromScrollContainer();
    document.addEventListener('scroll', onScroll, true);
    window.addEventListener('resize', syncFromScrollContainer);

    return () => {
      document.removeEventListener('scroll', onScroll, true);
      window.removeEventListener('resize', syncFromScrollContainer);
    };
  }, []);

  return (
    <Box sx={StyleSheet.header(theme, isScrolled)}>
      {loginAs && (
        <Box sx={StyleSheet.loginAsNotification}>Login as {user?.name}</Box>
      )}
      <ToastContainer />
      {headerSlot}
    </Box>
  );
}
